export const SERVIVE_PLAN_WORKFLOW_COMPONENT = {
  SERVICESELECTION: 0,
  SERVICEPLANOPTIONS: 1,
  SUMMARYANDPAYMENT: 2,
};

const SERVICE_PLAN_WORKFLOW_TYPE = {
  NEWSUBSCRIPTION: {
    id: 0,
    steps: [
      SERVIVE_PLAN_WORKFLOW_COMPONENT.SERVICESELECTION,
      SERVIVE_PLAN_WORKFLOW_COMPONENT.SERVICEPLANOPTIONS,
      SERVIVE_PLAN_WORKFLOW_COMPONENT.SUMMARYANDPAYMENT,
    ],
    options: {
      billMeReadOnly: false,
      allowChangePlan: true,
      showNone: false,
    },
  },
  CHANGEPLAN: {
    id: 1,
    steps: [
      SERVIVE_PLAN_WORKFLOW_COMPONENT.SERVICESELECTION,
      SERVIVE_PLAN_WORKFLOW_COMPONENT.SERVICEPLANOPTIONS,
      SERVIVE_PLAN_WORKFLOW_COMPONENT.SUMMARYANDPAYMENT,
    ],
    options: {
      billMeReadOnly: false,
      allowChangePlan: true,
      showNone: true,
    },
  },
  CHANGEPAYMENTPERIOD: {
    id: 2,
    steps: [
      SERVIVE_PLAN_WORKFLOW_COMPONENT.SERVICEPLANOPTIONS,
      SERVIVE_PLAN_WORKFLOW_COMPONENT.SUMMARYANDPAYMENT,
    ],
    options: {
      billMeReadOnly: false,
      allowChangePlan: true,
      showNone: true,
    },
  },
  PAYBALANCE: {
    id: 3,
    steps: [
      SERVIVE_PLAN_WORKFLOW_COMPONENT.SUMMARYANDPAYMENT,
    ],
    options: {
      billMeReadOnly: false,
      allowChangePlan: true,
      showNone: true,
    },
  },
  PAYINADVANCE: {
    id: 4,
    steps: [
      SERVIVE_PLAN_WORKFLOW_COMPONENT.SERVICEPLANOPTIONS,
      SERVIVE_PLAN_WORKFLOW_COMPONENT.SUMMARYANDPAYMENT,
    ],
    options: {
      billMeReadOnly: true,
      allowChangePlan: false,
      showNone: false,
    },
  },
};

export const SERVICE_PLAN_PAYMENT_PERIOD = {
  MONTHLY: 'monthly',
  YEARLY: 'yearly',
};

export const SERVICE_PLAN_PAYMENT_METHOD = {
  CREDIT_CARD_ON_FILE: 'credit-card-on-file',
  NEW_CREDIT_CARD: 'new-credit-card',
  CHECK_OR_BANK_TRANSFER: 'check-or-bank-transfer',
};

export default SERVICE_PLAN_WORKFLOW_TYPE;
